/* Seora native cart enhancements: progress bar, coupon estimate, recommendations. */
(function () {
  'use strict';

  if (window.__seoraCartInit) return;
  window.__seoraCartInit = true;

  var ANCHORS = ['seora-cart-progress-section', 'seora-cart-extras-section'];

  /* Seora sections present on this page, with their real (template--...) section ids. */
  function seoraTargets() {
    var out = [];
    ANCHORS.forEach(function (anchor) {
      var el = document.getElementById(anchor);
      var id = el && el.getAttribute('data-id');
      if (id) out.push({ anchor: anchor, sectionId: id });
    });
    return out;
  }

  function dawnTargets() {
    var out = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (anchor) {
      var el = document.getElementById(anchor);
      var id = el && el.getAttribute('data-id');
      if (id) out.push({ anchor: anchor, sectionId: id });
    });
    return out;
  }

  function isCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  /* Fetch the given sections and replace the innerHTML of each anchor element. */
  function refresh(targets) {
    if (!targets.length) return Promise.resolve();
    var ids = targets.map(function (t) { return t.sectionId; });
    var url = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        targets.forEach(function (t) {
          var html = data[t.sectionId];
          if (!html) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(t.anchor);
          var live = document.getElementById(t.anchor);
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        });
      });
  }

  /*
   * The cart drawer is present on the cart page too, but Dawn never re-renders it
   * from there - so after a quantity change on /cart the drawer would still show
   * the old totals, progress tier and coupon estimate. Re-render it ourselves.
   */
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var live = document.getElementById('CartDrawer');
    if (!drawer || !live) return Promise.resolve();

    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
        if (!fresh) return;

        live.innerHTML = fresh.innerHTML;

        /* Dawn binds this listener in renderContents(); rebind after replacing markup. */
        var overlay = live.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }

        /* The is-empty class lives on <cart-drawer>, outside the replaced markup. */
        if (fresh.querySelector('.cart-item')) {
          drawer.classList.remove('is-empty');
        } else {
          drawer.classList.add('is-empty');
        }
      });
  }

  function refreshSeora() {
    var jobs = [refresh(seoraTargets())];
    if (isCartPage()) jobs.push(refreshDrawer());
    return Promise.all(jobs).catch(function () {});
  }

  /* --- Copy coupon code ------------------------------------------------ */

  function copyCoupon(btn) {
    var code = btn.getAttribute('data-seora-copy');
    if (!code) return;
    var label = btn.querySelector('[data-seora-copy-label]') || btn;
    var original = label.textContent;

    var done = function () {
      label.textContent = 'Copied ' + code;
      btn.classList.add('is-copied');
      setTimeout(function () {
        label.textContent = original;
        btn.classList.remove('is-copied');
      }, 1800);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    }
  }

  /* --- Add from recommendation carousel -------------------------------- */

  function addFromRecommendation(btn) {
    var variantId = btn.getAttribute('data-seora-add');
    if (!variantId || btn.hasAttribute('disabled')) return;

    var original = btn.textContent;
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Adding...';

    var drawer = document.querySelector('cart-drawer');
    var useDrawer = !!drawer && !isCartPage();
    var payload = { items: [{ id: Number(variantId), quantity: 1 }] };

    if (useDrawer) {
      payload.sections = ['cart-drawer', 'cart-icon-bubble'];
      payload.sections_url = window.location.pathname;
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'Could not add to cart');

        if (useDrawer && state.sections) {
          drawer.renderContents(state);
        } else {
          refresh(dawnTargets().concat(seoraTargets()))
            .then(refreshDrawer)
            .catch(function () { window.location.reload(); });
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'seora-cart-rec' });
        }
      })
      .catch(function () {
        btn.textContent = original;
        btn.removeAttribute('disabled');
      });
  }

  /* --- Wiring ---------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var copy = event.target.closest('[data-seora-copy]');
    if (copy) {
      event.preventDefault();
      copyCoupon(copy);
      return;
    }
    var add = event.target.closest('[data-seora-add]');
    if (add) {
      event.preventDefault();
      addFromRecommendation(add);
    }
  });

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        /* Our own add already refreshed everything it needed to. */
        if (event && event.source === 'seora-cart-rec') return;
        refreshSeora();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
